import { render, staticRenderFns } from "./_DisposalBasic.vue?vue&type=template&id=8841a2d6&"
import script from "./_DisposalBasic.vue?vue&type=script&lang=js&"
export * from "./_DisposalBasic.vue?vue&type=script&lang=js&"
import style0 from "./_DisposalBasic.vue?vue&type=style&index=0&id=8841a2d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports